export default __webpack_public_path__ + "static/bsfi-scratch-to-reveal-8169ae54d7048da548e44f72e315ad24.gif";